import { useState } from 'react';

interface IFileService {
  file?: File | null;

  upload(accept?: string): void;
}

const useFile = (): IFileService => {
  const [file, setFile] = useState<File | null>();

  const upload = (accept?: string) => {
    const input = document.createElement('input');
    input.type = 'file';
    if (accept) {
      input.accept = accept;
    }
    input.onchange = () => {
      setFile(input.files?.item(0));
      input.remove();
    };
    input.click();
  };

  return { upload, file };
};

export default useFile;
